angular.module('wbDashboard').controller('ProfileBanksControllerAurea',
    ['$scope', '$q', '$uibModal', 'User', 'Account', 'Message', 'PlaidService',
function ($scope, $q, $uibModal, User, Account, Message, PlaidService) {
    $scope.pageData.errorMsg = null;

    $scope.linkStatuses = Account.bankLinkStatuses;
    $scope.linkOldStatuses = Account.bankLinkOldStatuses;
    $scope.bankAccounts = {};
    $scope.ach = {};
    //$scope.PS = PlaidService;

    $scope.pageData.plaidPublicToken = null;
    $scope.pageData.plaidAddToken = null;

    Message.clear("bankPending");

    $scope.$watch(User.getOverview, function(overview) {
        if (overview) {
            $scope.accounts = overview.account_overview;

            //overview v3 will use overview.bank_accounts
        }
    });

    // update to overview when ready
    User.retrieveBankAccounts();
    $scope.$watch(User.getBankAccounts, function(bankAccounts) {
        if (bankAccounts) {
            $scope.bankAccounts = bankAccounts;

            $scope.bankAccounts.current = bankAccounts.active || bankAccounts.pending;

        }
    });


    //stop current bank being verified only if not initial bank
    $scope.bankCancel = function () {

        var modalInstance = $uibModal.open({
            templateUrl: 'modal-confirm-bank-cancel.tpl.html',
            scope:$scope,
            size: 'md',
            windowClass:'confirm-modal modal-confirm-bank-cancel'
        });

        modalInstance.result.then(function (selectedItem) {
            $scope.pageData.canceling = true;
            $scope.pageData.errorMsg = null;
            Account.cancelBank().then(function (response) {
                Message.set({
                    "text" : "Your new bank account request has been canceled!",
                    "type" : "info"
                });

                User.retrieveOverview(true);
                return User.retrieveBankAccounts(true);
            }).catch(function(response) {
                try {
                    $scope.pageData.errorMsg = response.data.error.cancel;
                } catch (err) {
                    $scope.pageData.errorMsg = "Something went wrong with your request, please refresh and try again or contact support@axosinvest.com";
                }
            }).finally(function() {
                $scope.pageData.canceling = false;
            });

        }).catch(angular.noop); //dismissed/cancelled
    };


    /**
     ***********************************************
     * Handle Bank Account / Micro-Deposit Verification
     ***********************************************
     */
    PlaidService.retrievePlaidAddToken();

    $scope.submitMicros = function() {
        $scope.pageData.sending = true;
        $scope.pageData.errorMsg = null;

        var data = {
            amount1: $scope.ach.amount1 / 100,
            amount2: $scope.ach.amount2 / 100
        };

        return Account.verifyAch(data.amount1, data.amount2).catch(function(error) {
            $scope.pageData.errorMsg = error.message;
            if (error.refreshAccount) {
                return $q.all([User.retrieveOverview(true), User.retrieveBankAccounts(true)]).then(function() {
                    throw error;
                });
            }
            throw error;
        }).then(function(response) {
            Message.set({
                type: "success",
                text: "Your micro-deposits have been successfully submitted."
            });

            User.retrieveOverview(true);
            return User.retrieveBankAccounts(true);
        }).then(function() {
            $scope.$state.go('base.overview', {}, {location: 'replace'});
        }).catch(function() {
            //do nothing
        }).finally(function() {
            $scope.pageData.sending = false;
        });
    };

    $scope.reinitiateLink = function() {
        $scope.pageData.sending = true;
        $scope.pageData.errorMsg = null;
        $scope.initiateLinkSuccess = false;

        Account.reinitiateBank($scope.bankAccounts.pending.id).catch(function (response) {
            if (response.data.error.status) {
                $scope.pageData.errorMsg = response.data.error.status;
            } else {
                $scope.pageData.errorMsg = "Something went wrong with your request, please contact support@axosinvest.com to reinitiate your deposits.";
            }
            throw response;
        }).then(function() {
            $scope.initiateLinkSuccess = true;

            User.retrieveOverview(true);
            return User.retrieveBankAccounts(true);
        }).finally(function() {
            $scope.pageData.sending = false;
        });

    };

    $scope.openPlaidMicros = function() {
        if (!$scope.wbBeta) {
            $scope.disabledModal();
            return;
        }

        if (!$scope.pageData.plaidOpen) {

            let openPlaidMicroTimestamp = new Date().getTime();

            PlaidService.retrievePlaidAddToken().then(function(addToken) {
                $scope.pageData.plaidAddToken = addToken;

                $scope.pageData.plaidOpen = true;

                if ( $scope.pageData.plaidPublicToken ) {
                    return $scope.pageData.plaidPublicToken;
                } else {
                    return PlaidService.retrievePlaidBankToken($scope.bankAccounts.pending.uuid).then(function(plaidToken) {
                        $scope.pageData.plaidPublicToken = plaidToken;
                        return plaidToken;
                    });
                }
            }).then(function(plaidToken) {
                let createConfig = {
                    onSuccess: function(public_token, metadata) {

                        //update micro status here
                        $scope.completePlaidMicros();

                        $scope.$apply();
                    },
                    onExit: function(err, metadata) {

                        $scope.pageData.plaidPublicToken = null;

                        if (err) {
                            let errData = { error: err };

                            PlaidService.updatePlaidMicros($scope.bankAccounts.pending.uuid, 'fail', errData).then(function() {
                                User.retrieveOverview(true);
                                User.retrieveDetail(true);
                                return User.retrieveBankAccounts(true);
                            }).finally(function() {
                                //For failed micros:
                                // err.error_code === "TOO_MANY_VERIFICATION_ATTEMPTS"
                                if (err) {
                                    let msg = "There was an issue linking your bank.";
                                    if (err.error_message) {
                                        msg += " " + err.error_message;
                                    }
                                    Message.set({
                                        key: 'plaidError',
                                        text: msg,
                                        type: 'warning'
                                    });
                                }
                                $scope.pageData.plaidOpen = false;
                            });
                        } else {
                            if (new Date().getTime() - openPlaidMicroTimestamp < 5000) {
                                //if micros were already verified, but wasn't registered 'complete',
                                //plaid widget closes without opening and doesn't indicate the reason
                                //so just in case
                                $scope.completePlaidMicros();
                            }

                            $scope.pageData.plaidOpen = false;
                        }

                        $scope.$apply();
                    },
                    token: plaidToken,
                    // token: $scope.pageData.plaidAddToken
                };

                PlaidService.create(createConfig);

                $scope.pageData.plaidOpen = true;
                PlaidService.clear();
                PlaidService.open();

            }).catch(function() {
                $scope.pageData.plaidOpen = false;
            }).finally(function() {
            });
        }
    };
    $scope.completePlaidMicros = function() {
        $scope.disabledModal();
        return;

        PlaidService.updatePlaidMicros($scope.bankAccounts.pending.uuid, 'confirm').then(function() {
            User.retrieveOverview(true);
            User.retrieveDetail(true);
            return User.retrieveBankAccounts(true);
        }).finally(function() {
            $scope.pageData.plaidOpen = false;
            $scope.pageData.plaidPublicToken = null;
        });
    };


    $scope.openPlaid = function(micros = false) {
        if (!$scope.wbBeta) {
            $scope.disabledModal();
            return;
        }

        if (!$scope.pageData.plaidOpen) {

            var details = User.getDetail();
            var overview = User.getOverview();

            PlaidService.retrievePlaidAddToken().then(function(addToken) {
                $scope.pageData.plaidAddToken = addToken;

                let createConfig = {
                    onSuccess: function(public_token, metadata) {
                        $scope.addPlaidBank(public_token, metadata);
                    },
                    onExit: function(err, metadata) {
                        $scope.pageData.plaidOpen = false;
                        $scope.$apply();
                    },
                    userLegalName: details.detail.legal_name || (details.detail.first_name + " " + details.detail.last_name),
                    userEmailAddress: overview.user.email,
                    webhook: PlaidService.getWebhook(overview.user.user_code),
                    token: $scope.pageData.plaidAddToken
                };

                PlaidService.create(createConfig);

                $scope.pageData.plaidOpen = true;
                PlaidService.clear();
                PlaidService.open();

            });


        }
    };
    $scope.addPlaidBank = function(public_token, metadata) {
        $scope.pageData.sending = true;
        $scope.pageData.errorMsg = null;

        let data = {
            plaid_bank: {
                account_id: metadata.account_id,
                public_token: public_token,
                account: metadata.account,
            }
        };

        Account.addBank(data).then(function(response) {

            PlaidService.clear();

            let message;
            if (metadata && metadata.account && metadata.account.verification_status === "pending_manual_verification") {
                message = "All set - your micro deposits will show up in your account shortly.";
            } else {
                message = "All set - your new bank account is linked";
            }
            // else {
            //     //this is an unknown case
            //     message = "All set - your bank info has been submitted.";
            // }

            Message.set({
                "text": message,
                "type": "success"
            });

        }).catch(function (response) {
            $scope.pageData.errorMsg = "Something went wrong, please try again. If you continue to have problems, please email support@axosinvest.com.";
            return $q.reject();
        }).then(function (response) {
            User.retrieveOverview(true);
            return User.retrieveBankAccounts(true);
        }).finally(function () {
            $scope.pageData.plaidOpen = false;
            $scope.pageData.sending = false;
        });
    };

    $scope.disabledModal = function() {
        var modalInstance = $uibModal.open({
            templateUrl: 'modal-bank-modify-disabled.tpl.html',
            scope:$scope,
            size: 'md',
            windowClass:''
        });

        modalInstance.result.then(function (selectedItem) {}).catch(angular.noop); //dismissed/cancelled
    }
}]);
